
import { useEffect, useState, useMemo } from "react";

import API from "../services/api";

import {

  FileText,
  Wallet,
  CheckCircle,
  Clock,
  TrendingUp,
  Users

} from "lucide-react";

import StatCard
from "../components/ui/StatCard";

import DataTable
from "../components/ui/DataTable";

import StatusBadge
from "../components/ui/StatusBadge";

import FilterBar
from "../components/ui/FilterBar";
import CEOAIChatbot
from "../components/CEOAIChatbot";

export default function Dashboard() {

  // =====================================
  // STATES
  // =====================================

  const [claims, setClaims] =
    useState([]);

  const [dealers, setDealers] =
    useState([]);

  const [managers, setManagers] =
    useState([]);

  const [topCategories,
    setTopCategories] =
    useState([]);

  const [selectedDealer,
    setSelectedDealer] =
    useState("");

  const [selectedManager,
    setSelectedManager] =
    useState("");

  const [loading,
    setLoading] =
    useState(true);

  const [role,
    setRole] =
    useState("");

  const [search,
    setSearch] =
    useState("");

  const [date,
    setDate] =
    useState("");

  const [stats,
    setStats] =
    useState({});

    const [qrAging,
  setQrAging] =
  useState({});

  const [selectedCategory,
  setSelectedCategory] =
  useState("");

  const [categories,
  setCategories] =
  useState([]);

  // =====================================
  // INIT
  // =====================================

  useEffect(() => {

    const init = async () => {

      try {

        const token =
          localStorage.getItem(
            "token"
          );

        if (!token) {

          window.location =
            "/login";

          return;
        }

        const payload =
          JSON.parse(
            atob(
              token.split(".")[1]
            )
          );

        const userRole =
          String(
            payload.role || ""
          )
            .toLowerCase()
            .trim();

        setRole(userRole);

        await loadAll(
          userRole
        );

      } catch (err) {

        console.log(err);
      }
    };

    init();

  }, []);



// =====================================
// LOAD EVERYTHING
// =====================================

const loadAll = async (
  userRole
) => {

  try {

    setLoading(true);

    await Promise.all([

      loadClaims(userRole),

      loadStats(userRole),
      loadCategories(),

      (
        userRole === "ceo"

        ||

        userRole === "admin"
      )

        ? loadQRAging()

        : Promise.resolve(),

      userRole ===
      "ceo"

        ? loadTopCategories()

        : Promise.resolve(),

      userRole ===
      "manager"

        ? loadDealers()

        : Promise.resolve(),

      userRole ===
      "ceo"

        ? loadManagers()

        : Promise.resolve()

    ]);

  } catch (err) {

    console.log(err);

  } finally {

    setLoading(false);
  }
};
  // =====================================
  // LOAD CLAIMS
  // =====================================

  const loadClaims = async (
    userRole,
    managerId = ""
  ) => {

    try {

      let url = "";

      if (
        userRole ===
        "manager"
      ) {

        url =
          "/manager/claims";
      }

      else if (
        userRole ===
        "ceo"
      ) {

        url =
          `/ceo/claims${
            managerId

            ? `?manager_id=${managerId}`

            : ""
          }`;
      }

      else if (
        userRole ===
        "finance"
      ) {

        url =
          "/finance/claims";
      }

      else if (
        userRole ===
        "admin"
      ) {

        url =
          "/admin/claims";
      }

      if (!url) return;

      const res =
        await API.get(url);

      setClaims(
        res.data || []
      );

    } catch (err) {

      console.log(err);
    }
  };

  // =====================================
  // LOAD STATS
  // =====================================

  const loadStats = async (
    userRole,
    managerId = ""
  ) => {

    try {

      let url = "";

      if (
        userRole ===
        "manager"
      ) {

        url =
          "/claims/dashboard-stats";
      }

      else if (
        userRole ===
        "ceo"
      ) {

        url =
          `/ceo/dashboard${
            managerId

            ? `?manager_id=${managerId}`

            : ""
          }`;
      }

      else if (
        userRole ===
        "admin"
      ) {

        url =
          "/dashboard";
      }

      else if (
        userRole ===
        "finance"
      ) {

        url =
          "/finance/dashboard";
      }

      if (!url) return;

      const res =
        await API.get(url);

      setStats(
        res.data || {}
      );

    } catch (err) {

      console.log(err);
    }
  };

  // =====================================
  // LOAD DEALERS
  // =====================================

  const loadDealers =
    async () => {

      try {

        const res =
          await API.get(
            "/manager/dealers"
          );

        setDealers(
          res.data || []
        );

      } catch (err) {

        console.log(err);
      }
    };

  // =====================================
  // LOAD MANAGERS
  // =====================================

  const loadManagers =
    async () => {

      try {

        const res =
          await API.get(
            "/ceo/managers"
          );

        setManagers(
          res.data || []
        );

      } catch (err) {

        console.log(err);
      }
    };
// =====================================
// LOAD CATEGORIES
// =====================================

const loadCategories =
  async () => {

    try {

      const res =
        await API.get(
          "/categories"
        );

      setCategories(
        res.data || []
      );

    } catch (err) {

      console.log(err);
    }
  };
  // =====================================
  // LOAD TOP CATEGORIES
  // =====================================

  const loadTopCategories =
    async () => {

      try {

        const res =
          await API.get(
            "/ceo/top-categories"
          );

        setTopCategories(
          res.data || []
        );

      } catch (err) {

        console.log(err);
      }
    };


// =====================================
// LOAD QR AGING
// =====================================

const loadQRAging =
  async (
    category = ""
  ) => {

    try {

      const query =
        category

          ? `?category_id=${category}`

          : "";

      const res =
        await API.get(
          `/qr/aging-analytics${query}`
        );

      console.log(
        "FINAL QR AGING:",
        res.data
      );

      setQrAging({

        fresh:
          parseInt(
            res.data?.fresh || 0
          ),

        medium:
          parseInt(
            res.data?.medium || 0
          ),

        old_stock:
          parseInt(
            res.data?.old_stock || 0
          ),

        critical:
          parseInt(
            res.data?.critical || 0
          )
      });

    } catch (err) {

      console.log(err);
    }
  };
  // =====================================
  // CEO FILTER
  // =====================================

  const handleManagerChange =
    async (value) => {

      setSelectedManager(
        value
      );

      await Promise.all([

        loadStats(
          "ceo",
          value
        ),

        loadClaims(
          "ceo",
          value
        )
      ]);
    };

  // =====================================
  // CLEAR FILTERS
  // =====================================

  const clearFilters = () => {

    setSearch("");

    setDate("");

    setSelectedManager("");

    setSelectedDealer("");
  };

  // =====================================
  // FILTER CLAIMS
  // =====================================

  const filteredClaims =
    useMemo(() => {

      return claims.filter(
        (c) => {

          return (

            (
              !selectedDealer ||

              c.dealer_id ==
              selectedDealer
            )

            &&

            (
              !search ||

              c.customer_name
                ?.toLowerCase()
                .includes(
                  search
                  .toLowerCase()
                )

              ||

              c.customer_mobile
                ?.includes(
                  search
                )
            )

            &&

            (
              !date ||

              new Date(
                c.created_at
              )
                .toISOString()
                .slice(0, 10)

              === date
            )
          );
        }
      );

    }, [

      claims,
      selectedDealer,
      search,
      date

    ]);

  // =====================================
  // FORMATTER
  // =====================================

  const format = (num) =>

    Number(num || 0)
      .toLocaleString();

  // =====================================
  // TABLE COLUMNS
  // =====================================

  const columns = [

    {
      key: "dealer_name",
      title: "Dealer"
    },

    {
      key: "customer_name",
      title: "Customer"
    },

    {
      key: "customer_mobile",
      title: "Mobile"
    },

    {
      key: "claim_amount",
      title: "Amount",

      render: (row) => (

        <span
          className="
          font-bold
          text-gray-800
        "
        >
          Rs {
            format(
              row.claim_amount
            )
          }
        </span>
      )
    },

    {
      key: "manager_status",
      title: "Status",

      render: (row) => (

        <StatusBadge
          status={
            row.manager_status
          }
        />
      )
    }
  ];

  // =====================================
  // LOADING
  // =====================================

  if (loading) {

    return (

      <div
        className="
        flex
        items-center
        justify-center
        h-[70vh]
      "
      >

        <div
          className="
          text-xl
          font-semibold
          text-gray-500
        "
        >
          Loading Dashboard...
        </div>

      </div>
    );
  }

  // =====================================
  // UI
  // =====================================

  return (

    <div
      className="
      space-y-8
    "
    >

      {/* HEADER */}

      <div
        className="
        flex
        flex-col
        md:flex-row
        md:items-center
        md:justify-between
        gap-4
      "
      >

        <div>

          <h1
            className="
            text-4xl
            font-bold
            text-gray-800
          "
          >
            📊 Dashboard
          </h1>

          <p
            className="
            text-gray-500
            mt-2
          "
          >
            Welcome back to
            Canon ERP System
          </p>

        </div>

        <div
          className="
          bg-white
          rounded-2xl
          px-5
          py-3
          shadow-sm
          border
          border-gray-100
        "
        >

          <p
            className="
            text-sm
            text-gray-500
          "
          >
            Logged in as
          </p>

          <p
            className="
            font-bold
            capitalize
          "
          >
            {role}
          </p>

        </div>

      </div>

      {/* KPI GRID */}

      <div
        className="
        grid
        grid-cols-1
        md:grid-cols-2
        xl:grid-cols-4
        gap-6
      "
      >

        <StatCard
          title="Total Claims"
          value={
            stats.totalClaims || 0
          }
          icon={FileText}
          color="bg-blue-600"
          growth="+18%"
        />

        <StatCard
          title="Approved"
          value={
            stats.approvedCount || 0
          }
          icon={CheckCircle}
          color="bg-green-600"
          growth="+12%"
        />

        <StatCard
          title="Pending"
          value={
            stats.pendingCount || 0
          }
          icon={Clock}
          color="bg-yellow-500"
          growth="+8%"
        />

      <StatCard
  title="Total Payout"
  value={`Rs ${format(

    role === "ceo"

      ? stats.totalAmount

      : stats.total_claim_amount

  )}`}
  icon={Wallet}
  color="bg-primary"
  growth="+22%"
/>

      </div>
{/* =====================================
    QR AGING ANALYTICS
===================================== */}

{
  (
    role === "ceo"

    ||

    role === "admin"
  ) && (

    <div
      className="
      mt-4
    "
    >

      <div
        className="
        flex
        items-center
        justify-between
        mb-6
      "
      >

        <div>

          <h2
            className="
            text-2xl
            font-bold
            text-gray-800
          "
          >
            📦 Product Aging Analysis
          </h2>
          <div
  className="
  mb-6
  flex
  gap-4
"
>

  <select

    value={
      selectedCategory
    }

    onChange={

      async (e) => {

    console.log(
      "SELECTED CATEGORY:",
      e.target.value
    );

        setSelectedCategory(
          e.target.value
        );

        await loadQRAging(
          
          e.target.value
        );
      }
    }

    className="
    px-4
    py-3
    rounded-2xl
    border
    border-gray-200
    bg-white
    shadow-sm
    outline-none
  "
  >

    <option value="">
  All Categories
</option>

{
  categories.map(

    (cat) => (

      <option
        key={cat.id}
        value={
          cat.id
        }
      >

        {
          cat.category_name
        }

      </option>
    )
  )
}

  </select>

</div>

          <p
            className="
            text-gray-500
            mt-1
          "
          >
            Inventory aging overview
          </p>

        </div>

      </div>

      <div
        className="
        grid
        grid-cols-1
        md:grid-cols-2
        xl:grid-cols-4
        gap-6
      "
      >

        {/* FRESH */}

        <div
          className="
          bg-white
          rounded-3xl
          p-6
          border
          border-green-100
          shadow-sm
        "
        >

          <div
            className="
            flex
            items-center
            justify-between
          "
          >

            <div>

              <p
                className="
                text-green-600
                font-semibold
              "
              >
                Recent Added Products-Count
              </p>

              <h2
                className="
                text-5xl
                font-bold
                mt-4
                text-green-700
              "
              >
               {
  parseInt(
    qrAging.fresh || 0
  )
}
              </h2>

              <p
                className="
                text-gray-500
                mt-2
              "
              >
                0–30 Days
              </p>

            </div>

          </div>

        </div>

        {/* MEDIUM */}

        <div
          className="
          bg-white
          rounded-3xl
          p-6
          border
          border-yellow-100
          shadow-sm
        "
        >

          <div
            className="
            flex
            items-center
            justify-between
          "
          >

            <div>

              <p
                className="
                text-yellow-600
                font-semibold
              "
              >
                Medium Aging
              </p>

              <h2
                className="
                text-5xl
                font-bold
                mt-4
                text-yellow-700
              "
              >
                {
                  parseInt(
  qrAging.medium || 0
)
                }
              </h2>

              <p
                className="
                text-gray-500
                mt-2
              "
              >
                31–60 Days
              </p>

            </div>

          </div>

        </div>

        {/* OLD */}

        <div
          className="
          bg-white
          rounded-3xl
          p-6
          border
          border-orange-100
          shadow-sm
        "
        >

          <div
            className="
            flex
            items-center
            justify-between
          "
          >

            <div>

              <p
                className="
                text-orange-600
                font-semibold
              "
              >
                Old Stock
              </p>

              <h2
                className="
                text-5xl
                font-bold
                mt-4
                text-orange-700
              "
              >
                {
                  parseInt(
  qrAging.old_stock || 0
)
                }
              </h2>

              <p
                className="
                text-gray-500
                mt-2
              "
              >
                61–90 Days
              </p>

            </div>

          </div>

        </div>

        {/* CRITICAL */}

        <div
          className="
          bg-white
          rounded-3xl
          p-6
          border
          border-red-100
          shadow-sm
        "
        >

          <div
            className="
            flex
            items-center
            justify-between
          "
          >

            <div>

              <p
                className="
                text-red-600
                font-semibold
              "
              >
                Critical Aging
              </p>

              <h2
                className="
                text-5xl
                font-bold
                mt-4
                text-red-700
              "
              >
                {
                  parseInt(
  qrAging.critical || 0
)
                }
              </h2>

              <p
                className="
                text-gray-500
                mt-2
              "
              >
                90+ Days
              </p>

            </div>

          </div>

        </div>

      </div>

    </div>
  )
}
      {/* TOP CLAIM CATEGORIES */}

      {
        role === "ceo" && (

          <div>

            <div
              className="
              flex
              items-center
              justify-between
              mb-6
            "
            >

              <div>

                <h2
                  className="
                  text-2xl
                  font-bold
                  text-gray-800
                "
                >
                  📊 Top Claim Categories
                </h2>

                <p
                  className="
                  text-gray-500
                  mt-1
                "
                >
                  Highest performing categories
                </p>

              </div>

            </div>

            <div
              className="
              grid
              grid-cols-1
              md:grid-cols-2
              xl:grid-cols-4
              gap-6
            "
            >

              {
                topCategories.map(

                  (
                    item,
                    index
                  ) => (

                    <div
                      key={index}
                      className="
                      bg-white
                      rounded-3xl
                      p-6
                      shadow-sm
                      border
                      border-gray-100
                      hover:shadow-xl
                      transition-all
                    "
                    >

                      <div
                        className="
                        flex
                        items-center
                        justify-between
                        mb-5
                      "
                      >

                        <div
                          className="
                          w-14
                          h-14
                          rounded-2xl
                          bg-blue-100
                          text-blue-600
                          flex
                          items-center
                          justify-center
                          text-2xl
                          font-bold
                        "
                        >
                          {index + 1}
                        </div>

                        <div
                          className="
                          text-right
                        "
                        >

                          <p
                            className="
                            text-sm
                            text-gray-400
                          "
                          >
                            Total Amount
                          </p>

                          <p
                            className="
                            font-bold
                            text-primary
                          "
                          >
                            Rs {
                              format(
                                item.totalAmount
                              )
                            }
                          </p>

                        </div>

                      </div>

                      <h3
                        className="
                        text-2xl
                        font-bold
                        text-gray-800
                        mb-2
                      "
                      >
                        {
                          item.category_name
                        }
                      </h3>

                      <div
                        className="
                        flex
                        items-end
                        justify-between
                        mt-5
                      "
                      >

                        <div>

                          <p
                            className="
                            text-gray-500
                            text-sm
                          "
                          >
                            Total Claims
                          </p>

                          <h2
                            className="
                            text-4xl
                            font-bold
                            text-blue-600
                          "
                          >
                            {
                              item.totalClaims
                            }
                          </h2>

                        </div>

                        <div
                          className="
                          bg-green-100
                          text-green-700
                          px-3
                          py-1
                          rounded-xl
                          text-sm
                          font-semibold
                        "
                        >
                          Top
                        </div>

                      </div>

                    </div>
                  )
                )
              }

            </div>

          </div>
        )
      }

      {/* FILTER BAR */}

      <FilterBar

        search={search}
        setSearch={setSearch}

        date={date}
        setDate={setDate}

        selectedManager={
          selectedManager
        }

        setSelectedManager={
          handleManagerChange
        }

        managers={managers}

        role={role}

        clearFilters={
          clearFilters
        }
      />

      {/* MAIN GRID */}

      <div
        className="
        grid
        grid-cols-1
        xl:grid-cols-3
        gap-6
      "
      >

        <div
          className="
          xl:col-span-2
          space-y-6
        "
        >

          <div
            className="
            flex
            items-center
            justify-between
          "
          >

            <div>

              <h2
                className="
                text-2xl
                font-bold
                text-gray-800
              "
              >
                Recent Claims
              </h2>

              <p
                className="
                text-gray-500
                mt-1
              "
              >
                Latest claim activities
              </p>

            </div>

          </div>

          <DataTable

            columns={columns}

            data={
              filteredClaims
                .slice(0, 8)
            }

            emptyMessage="
            No claims found
          "
          />

        </div>

        <div
          className="
          space-y-6
        "
        >

          <div
            className="
            bg-white
            rounded-3xl
            p-6
            shadow-sm
            border
            border-gray-100
          "
          >

            <div
              className="
              flex
              items-center
              justify-between
            "
            >

              <div>

                <p
                  className="
                  text-gray-500
                "
                >
                  Active Dealers
                </p>

                <h2
                  className="
                  text-4xl
                  font-bold
                  mt-2
                  text-gray-800
                "
                >
                  {
                    dealers.length || 0
                  }
                </h2>

              </div>

              <div
                className="
                w-16
                h-16
                rounded-2xl
                bg-blue-100
                text-blue-600
                flex
                items-center
                justify-center
              "
              >

                <Users size={32} />

              </div>

            </div>

          </div>

          <div
            className="
            bg-gradient-to-br
            from-primary
            to-red-700
            text-white
            rounded-3xl
            p-6
            shadow-xl
          "
          >

            <div
              className="
              flex
              items-center
              justify-between
            "
            >

              <div>

                <p
                  className="
                  text-red-100
                "
                >
                  Monthly Growth
                </p>

                <h2
                  className="
                  text-5xl
                  font-bold
                  mt-3
                "
                >
                  +24%
                </h2>

              </div>

              <TrendingUp
                size={52}
              />

            </div>

            <p
              className="
              mt-6
              text-red-100
            "
            >
              Claims performance increased
              significantly this month.
            </p>

          </div>

        </div>

      </div>

      <CEOAIChatbot />

    </div>
  );
}